import { render, staticRenderFns } from "./PayLogin.vue?vue&type=template&id=22f85f30"
import script from "./PayLogin.vue?vue&type=script&lang=js"
export * from "./PayLogin.vue?vue&type=script&lang=js"
import style0 from "./PayLogin.vue?vue&type=style&index=0&id=22f85f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports